import type { Resource } from '../../';
export const country_countries_ES: Resource = {"default":"Spain"};
